import store from '@/store/index'

function checkPermission (el, binding) {
  const { value } = binding
  const permission = store.state.login.userInfo.paraNameList
  if (value && value instanceof Array) {
    if (value.length) {
      const permissionRoles = value

      const hasPermission = permission.some(role => {
        return permissionRoles.includes(role)
      })

      if (!hasPermission) {
        el.parentNode && el.parentNode.removeChild(el)
      }
    }
  } else {
    throw new Error('need permission! Like v-permission="[\'admin\',\'editor\']"')
  }
}

export default {
  inserted (el, binding) {
    checkPermission(el, binding)
  },
  update (el, binding) {
    checkPermission(el, binding)
  }
}
